import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { renameDocument } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type RenameDocumentParams = {
  documentId: number;
  newName: string;
};

export const useRenameDocument = (
  options: UseMutationOptions<
    unknown,
    unknown,
    RenameDocumentParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ documentId, newName }: RenameDocumentParams) => {
      return extractData(
        renameDocument({ path: { documentId }, query: { name: newName } })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
